/**
 * The mount. Router, strict mode, one stylesheet, nothing else.
 *
 * BrowserRouter rather than a hash router, because `wrangler.jsonc` sets the asset server's
 * `not_found_handling` to `single-page-application`, so a deep link is answered with index.html
 * and resolved here.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import './styles.css';

const mount = document.getElementById('root');
if (!mount) throw new Error('index.html has no element with id "root" to mount into.');

createRoot(mount).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
